"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedListChooserState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const multi_list_chooser_state_1 = require("./multi.list.chooser.state");
class NestedListChooserState extends multi_list_chooser_state_1.MultiChooserState {
    constructor(field) {
        super(field.schema.displayName);
        this.field = field;
        this.formField = field.schema;
        this.setValue(this.field.value);
    }
    get displayValue() {
        return this.field.hasValue() ? this.field.displayValue : null;
    }
    get groups() {
        const groups = [];
        const selections = this.getSelections(this.value);
        let group = this.formField.options;
        for (const selection of selections) {
            if (group == null) {
                throw new Error(`NestedList group not found for selection "${selection}"`);
            }
            const items = group.values.map((groupValue, i) => ({
                key: groupValue.value,
                value: groupValue.value,
                color: groupValue.color,
            }));
            const selectedValue = group.values.find((groupValue) => String(groupValue.value) === selection);
            if (selectedValue == null) {
                items.unshift({ key: selection, value: selection + '*' });
            }
            groups.push({
                title: group.title,
                items,
                selected: selectedValue != null ? selectedValue.value : items[0].value,
            });
            group = selectedValue != null ? selectedValue.options : null;
        }
        return groups;
    }
    setValue(values) {
        if (values == null || values.length === 0) {
            this._value = null;
            return;
        }
        this._value = this.getSelections(values);
    }
    selectDefaultValue() {
        this._value = this.getSelections([]);
    }
    //We need to override the generic getAllOptions function as the nested list need to keep the value of all the selected nodes instead of only the last one.
    getAllOptions() {
        let options = this.formField.options.values;
        let allOptions = [];
        for (let option of options) {
            NestedListChooserState.flatten(option, [], allOptions);
        }
        return allOptions;
    }
    static flatten(node, path = [], result = []) {
        let item = { key: node.value, value: node.value };
        if (!node.options) {
            result.push([...path, item]);
        }
        else {
            for (const child of node.options.values) {
                NestedListChooserState.flatten(child, [...path, item], result);
            }
        }
        return result;
    }
    getSelections(values) {
        values = values || [];
        const selections = [];
        let group = this.formField.options;
        for (const value of values) {
            selections.push(String(value));
            const selectedValue = group.values.find((f) => String(f.value) === value);
            group = selectedValue != null ? selectedValue.options : null;
        }
        const previousValues = this.value != null ? this.value : [];
        while (group != null && group.values.length > 0) {
            let selectedValue = group.values[0];
            // Try to match existing selection in new group
            const previousValue = previousValues[selections.length];
            if (previousValue != null) {
                // Use == to compare strings with numbers untill we fix typing
                const equalValue = group.values.find((v) => v.value == previousValue); // eslint-disable-line
                if (equalValue != null) {
                    selectedValue = equalValue;
                }
            }
            selections.push(String(selectedValue.value));
            group = selectedValue.options;
        }
        return selections;
    }
}
exports.NestedListChooserState = NestedListChooserState;
tslib_1.__decorate([
    mobx_1.computed
], NestedListChooserState.prototype, "displayValue", null);
tslib_1.__decorate([
    mobx_1.computed
], NestedListChooserState.prototype, "groups", null);
tslib_1.__decorate([
    mobx_1.action
], NestedListChooserState.prototype, "setValue", null);
tslib_1.__decorate([
    mobx_1.action
], NestedListChooserState.prototype, "selectDefaultValue", null);
//# sourceMappingURL=nested.list.chooser.state.js.map